import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { ModalContainer, ModalContent, Close } from './Modal.styled';

const Modal = ({ children, isOpen, toggle }) => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    }
  }, [isOpen]);

  return (
    <ModalContainer isOpen={isOpen} onClick={toggle}>
      <Close className="button-unstyled" onClick={toggle}>
        <i className="far fa-times"></i>
      </Close>
      <ModalContent onClick={(e) => e.preventDefault()}>
        {children}
      </ModalContent>
    </ModalContainer>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
};

export default Modal;
